import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeVisibility } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import { IChangeVisibility } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureSettings/StructureSettings.schema";
import __ from "src/utils/Translations";

const useChangeVisibility = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (switchState: IChangeVisibility) =>
      changeVisibility(companyId, structureId, switchState),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zapisano dane"), "success");
      queryClient.invalidateQueries({
        queryKey: ["structure-data", { companyId, structureId }],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się zapisać danych"), "error");
    },
  });
};

export default useChangeVisibility;
